import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface IOthersFormMeta {
    cardDrawer: FormInputMeta;
    activeDepositTape: FormInputMeta;
    dpmPocketClosed: FormInputMeta;

}

const othersFormMeta = {} as IOthersFormMeta;

othersFormMeta.cardDrawer = {
    name: "cardDrawer",
    type: "checkbox",
    label: "Tiroir Carte...",
    placeholder: "",
    validation: yup.boolean()
};

othersFormMeta.activeDepositTape = {
    name: "activeDepositTape",
    type: "checkbox",
    label: "Cassette de Dépot Actif",
    placeholder: "",
    validation: yup.boolean()
};

othersFormMeta.dpmPocketClosed = {
    name: "dpmPocketClosed",
    type: "checkbox",
    label: "DPM Pocket Fermé",
    placeholder: "",
    validation: yup.boolean()
};


export default othersFormMeta;